import { IV1GetMetaResponseSchema } from '../../repositories/search-offers-index/entities/get_meta/V1GetMetaResponseSchema';
import { ISearchMeta } from '../../types/searchMeta';

export function prepareSearchMeta(response: IV1GetMetaResponseSchema): ISearchMeta {
  return {
    count: response.count,
    queryString: response.querystring,
    seoPath: response.seoPath ? response.seoPath.replace(/\//g, '') : null,
    subdomain: response.subdomain,
  };
}
